<template>
  <div class="bg-primary pt-10 lg:p-16 gap-4 fixed inset-0 overflow-y-auto overflow-x-hidden">
    <div class="flex flex-col items-center bg-transparant text-primary mb-6">
      <RouterLink to="/"><XS2EventLogo /></RouterLink>
    </div>
    <div class="flex flex-col p-6 bg-background w-fit sm:min-w-[450px] max-w-lg rounded-xl shadow gap-4 m-auto">
      <h2 v-if="title" class="text-2xl font-bold text-center">{{ $t(title) }}</h2>
      <div v-if="description" class="text-center">
        <span>{{ $t(description) }}</span>
      </div>
      <slot></slot>
    </div>
    <slot name="footer"><AltPageFooter /></slot>
    <div class="fixed top-0 right-0 p-4">
      <LanguageMenu />
    </div>
    <button v-if="canGoBack" class="fixed hidden lg:flex left-3 top-3 gap-2 items-center" @click="goBack">
      <ArrowLeftIcon class="w-4" /> {{ $t("Back to the previous page") }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import XS2EventLogo from "../media/XS2EventLogo.vue";
import AltPageFooter from "./AltPageFooter.vue";
import LanguageMenu from "./menu/LanguageMenu.vue";
import { computed } from "vue";
import { ArrowLeftIcon } from "@heroicons/vue/20/solid";
// import FaceFill from "@/components/media/FaceFill.vue";
// import Appartment from "@/components/media/Appartment.vue";

const route = useRoute();

const title = computed(() => route.meta.title);
const description = computed(() => route.meta.description);

const canGoBack = computed(() => {
  return !!window.history.length && route.path != "/sign-in";
});

const goBack = () => window.history.back();
</script>
